module.exports = __webpack_public_path__ + "static/media/UKFlagicoi.d4a76f03.png";